export enum Type {
  Error = "error",
  Success = "success",
  Info = "info",
  Warning = "warning",
}

export interface Notification {
  type: Type;
  message: string;
  description?: string;
  error?: any;
}
